import { observer } from "mobx-react";
import moment from "moment";
import React, { useEffect } from "react";
import ConfigurationStore from "../../stores/ConfigurationStore";
import GlobalStore from "../../stores/GlobalStore";
import { Link } from "react-router-dom";

function ETAccounts(props) {
  useEffect(() => {
    ConfigurationStore.getEtAccounts();
    GlobalStore.pageName = "et-accounts";
  }, []);

  const edit = (id) => {
    props.history.push(`/et-account/edit/${id}`);
  };

  const onDelete = (id) => {
    let r = window.confirm("Are you sure to delete this account?");
    if (r) {
      ConfigurationStore.deleteEtAccount(id).then(() => {
        ConfigurationStore.getEtAccounts();
      });
    }
  };

  let { etAccounts = [] } = ConfigurationStore;
  return (
    <React.Fragment>
      <div className="table-info">
        <table border="0" cellSpacing="0">
          <thead>
            <tr>
              <th>Name</th>
              <th>Company Name</th>
              <th>Base URL</th>
              <th>Username</th>
              <th>Password</th>
              <th>API Key</th>
              <th>In-use</th>
              <th>Last used</th>
              <th>Client</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {etAccounts &&
              etAccounts.map((account) => {
                return (
                  <tr>
                    <td>{account.name}</td>
                    <td>{account.companyname}</td>
                    <td>{account.base_url}</td>
                    <td>{account.username}</td>
                    <td>{account.password}</td>
                    <td>{account.apikey}</td>
                    <td>
                      <span
                        className={`color-text ${
                          account.in_use ? `gr-color` : `rd-color`
                        }`}
                      >
                        {account.in_use ? "YES" : "NO"}
                      </span>
                    </td>
                    <td>
                      {moment(account.createdAt).format("DD/MM/YYYY hh:mm A")}
                    </td>
                    <td>{account?.client_data[0]?.code}</td>
                    <td>
                      <button
                        className="primarybtn"
                        onClick={() => edit(account._id)}
                      >
                        Edit
                      </button>
                      <button
                        disabled={account.in_use}
                        onClick={() => onDelete(account._id)}
                        className="primarybtn delete-btn"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })}
            <tr>
              <td>End of Data</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="bottom-button">
        <Link to="/et-account/add">
          <button className="primarybtn add-btn">+ Add Account</button>
        </Link>
      </div>
    </React.Fragment>
  );
}

export default observer(ETAccounts);
